import Confirm from './Confirm'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  ButtonGroup,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const StyledDialogActions = withStyles({
  root: {
    padding: 0,
  },
})(DialogActions)

const StyledButtonGroup = withStyles({
  grouped: {
    borderRadius: 0,
    padding: 10,
    fontWeight: 600,
  },
})(ButtonGroup)

const StyledDialog = withStyles({
  paper: {
    borderRadius: 15,
  },
})(Dialog)

const StyledTitle = withStyles({
  root: {
    fontWeight: 600,
    padding: 10,
    margin: '0 auto',
  },
})(DialogTitle)

export {
  Confirm,
  StyledTitle as Title,
  StyledButtonGroup as ButtonGroup,
  StyledDialog as Default,
  StyledDialogActions as Actions,
}
